import { DefaultButton, Spinner } from '@fluentui/react';
import { useState } from 'react';

import { popup } from '../../../../../addons/Popup';
import { store } from '../../../../../App/store';
import PdfDocument from '../../../PdfDocument';
import { actions } from '../../../slice';
import { getFormState } from '../../../slice/newFormReducers';

type Props = {
  fastMode?: boolean;
  onCompleted?: (success?: boolean) => any;
};

export default (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      {isLoading && <Spinner />}
      <DefaultButton
        text={"Taslağı Yazdır"}
        iconProps={{ iconName: "Print" }}
        disabled={isLoading}
        onClick={async () => {
          setIsLoading(true);
          await printTemplate();
          setIsLoading(false);
        }}
      />
    </>
  );
};

async function printTemplate() {
  const formState = getFormState();
  const employee = formState.employee;

  if (!employee || !employee.id || employee.pin === "0000") {
    actions.setFormVariable(["employee", undefined]);

    const promise = new Promise<boolean>((resolve) => {
      const formUUID = formState.UUID;
      const cancel = store.subscribe(async () => {
        const state = store.getState();
        const updatedFormState =
          formUUID && state.currentForm.newForms[formUUID];

        if (!updatedFormState) {
          cancel();
        } else if (employee) {
          cancel();

          resolve(printTemplate());
        }
      });

      setTimeout(cancel, 30000);
    });

    return await promise;
  }

  try {
    try {
      const pdfDocument = new PdfDocument({
        isTemplate: true,
      });

      await pdfDocument.print();
    } catch (e) {
      console.error(e);
      await popup("Yazdırma işleminde hata oluştu, manuel olarak yazdırın");
    }

    return true;
  } catch (e) {
    console.error(e);
    await popup("Hata Oluştu");
    return false;
  }
}
